import {
    Alert,
    Box,
    Button,
    CardContent, Grid,
    IconButton,
    LinearProgress, Table, TableBody, TableCell,
    TableContainer, TableHead, TableRow,
    TextField,
    Typography
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import {createPayment, getExpense} from "../expense.api";
import { RootState } from "../../../store";
import React, {useState} from "react";
import {Dropzone} from "@dropzone-ui/react";
import {Cancel, Check, DeleteForever, HighlightOffOutlined} from "@mui/icons-material";
import {userInfo} from "../../../shared/utils";
import axios from "axios";
import {baseUrl} from "../../../state";
import notificationError from "../../../shared/notificationError";
import notificationSuccess from "../../../shared/notificationSuccess";
import {InterfaceExpense} from "../expense.interface";

export default function ExpensePaid(props: { data: InterfaceExpense[] | null, onCancel: () => void, onSubmit: () => void, onDelete: (id: string) => void}) {

    const dispatch = useDispatch<any>()

    const { parameterGetData } = useSelector((state: RootState) => state.expense)

    const [reason, setReason] = useState("")
    const [filesQueue, setFilesQueue] = useState<any>([])
    const [isUploading, setIsUploading] = useState<boolean>(false)

    const [removeAttachmentIds, setRemoveAttachmentIds] = useState<Array<string>>([])

    // change it to invoice id
    const [currentBillingId, setCurrentBillingId] = useState<string | undefined>(undefined)

    const handleConfirm = async () => {
        // if (props.id !== null) {
            await dispatch(createPayment({
                token: userInfo().token,
                billingIds: props.data?.map((item) => item.id) as string[],
                invoiceNumber: ``,
                notes: reason,
            })).then((response: any) => {
                console.log()
                console.log(response.data?.status)
                if (response.payload?.data?.status) {
                    setIsUploading(true)
                    uploading(response.payload?.data?.data?.id)
                }
            })
            await dispatch(getExpense(parameterGetData))
            props.onSubmit()
        // }
    }

    // useEffect(() => {
    //     if (currentBillingId !== undefined && (!isUploading && filesQueue.length > 0 && filesQueue.filter((file: any) => file.uploadProgress < 100).length > 0)) {
    //         setIsUploading(true)
    //         uploading(currentBillingId)
    //     }
    // }, [filesQueue, currentBillingId])

    const uploading = async (billingId: string) => {
        let filesLocal: any = filesQueue
        let filesToUpload: any = filesLocal.filter((file: any) => file.uploadProgress === 0)
        if (filesToUpload.length > 0) {
            for (const i in filesToUpload) {
                try {
                    let data = new FormData();
                    data.append("billingPaymentId", billingId)
                    data.append("token", userInfo().token)
                    data.append("file", filesToUpload[i].file)
                    await axios.post(`${baseUrl}/newapi/Billing/UploadPaymentAttachments`, data, {
                        onUploadProgress: (progressEvent) => {
                            var percentCompleted = Math.round((progressEvent.loaded * 100) / (progressEvent.total || 1))
                            filesLocal = filesLocal.map((f: any) => {
                                if (f.name === filesToUpload[i].name) {
                                    return {
                                        ...f,
                                        uploadProgress: percentCompleted
                                    }
                                }
                                return f
                            })
                            setFilesQueue(filesLocal)
                        }
                    });
                } catch (error: any) {
                    console.log(error)
                    notificationError(error.response)
                }
            }
        }
        setIsUploading(false)
        notificationSuccess("Successfully add expense attachment")
    }

    const onChangeImage = async (filesLocal: any) => {
        if (filesLocal.length > 0) {
            if (filesLocal.length > 0) {
                setFilesQueue([
                    ...filesQueue,
                    ...Array.from(filesLocal).map((file: any) => {
                        return {
                            name: file.name,
                            uploadProgress: 0,
                            file: file.file
                        }
                    })
                ])
            }
        }
    }

    const onFileDelete = (id: string) => () => {
        setFilesQueue(filesQueue.filter((file: any) => file.id !== id))
        setRemoveAttachmentIds([...removeAttachmentIds, id])
    }

    const handleDelete = (e: React.MouseEvent<HTMLButtonElement>, id: string) => {
        e.stopPropagation();
        props.onDelete(id);
    }

    return (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
            {/*<Typography variant="h6">Reject Reason</Typography>*/}
            <Box sx={{
                borderRadius: '20px',
                backgroundColor: '#ffffff'
            }}>
                <CardContent>
                    <TableContainer sx={{maxHeight: 400}}>
                        <Table stickyHeader>
                            <TableHead>
                                <TableRow>
                                    <TableCell>Created Date</TableCell>
                                    <TableCell>Fielder</TableCell>
                                    <TableCell>Notes</TableCell>
                                    <TableCell>Amount</TableCell>
                                    <TableCell>Action</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {props?.data?.map((data, index) => (
                                    <TableRow key={`mileage-${index}`} className="hover">
                                        <TableCell>{data.createdDateString || '-'}</TableCell>
                                        <TableCell>{data.fieldingRequest || '-'}</TableCell>
                                        <TableCell>{data.notes}</TableCell>
                                        <TableCell>{data.amount}</TableCell>
                                        <TableCell width={'60px'}>
                                            <Button color="error" startIcon={<HighlightOffOutlined/>}
                                                    onClick={(e) => handleDelete(e, data.id)}></Button>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <Box mt={2}>
                        <Alert icon={false} severity="info" style={{borderRadius: '10px'}} sx={{
                            //MuiAlert-message
                            '& .MuiAlert-message': {
                                display: 'flex',
                                width: '100%',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                            }
                        }}>
                            <Grid display={'flex'} width={'100%'}>
                                <Typography fontWeight={600} color={'#0b75bb'} display={'flex'} flexGrow={1}>
                                    Total Payment
                                </Typography>
                                <Typography fontWeight={600} color={'#0b75bb'}>
                                    {props?.data?.reduce((a, b) => a + b.amount, 0).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                </Typography>
                            </Grid>
                        </Alert>
                    </Box>
                </CardContent>
            </Box>
            <TextField label={'Notes'} multiline minRows={5} value={reason} onChange={(e) => setReason(e.target.value)} />
            <Box>
                {/*ony accept image*/}
                <Typography>Attachments</Typography>
                <Dropzone onChange={onChangeImage} header={false} accept="image/*" disabled={isUploading}/>
                {filesQueue.map((file: any) => (
                    <Box key={file.name}>
                        <Box sx={{display: "flex", alignItems: "center", justifyContent: "space-between"}}>
                            {file.name}
                            <Box>
                                <IconButton onClick={
                                    () => {
                                        if (file.uploadProgress < 100) {
                                            // delete
                                            setFilesQueue(filesQueue.filter((f: any) => f.name !== file.name));

                                        } else {
                                            // do nothing, already completed
                                        }
                                    }
                                }>
                                    {file.uploadProgress < 100
                                        ? (
                                            <Cancel/>
                                        )
                                        : (
                                            <Check color="success"/>
                                        )
                                    }
                                </IconButton>
                                {
                                    (file.uploadProgress === 100) && (
                                        <IconButton onClick={onFileDelete(file.id)}>
                                            <DeleteForever color="error"/>
                                        </IconButton>
                                    )
                                }
                            </Box>
                        </Box>
                        <LinearProgress variant="determinate" value={file.uploadProgress}/>
                    </Box>
                ))}
            </Box>
            {/*left and right*/}
            <Box display={"flex"} justifyContent={"space-between"} mt={2} gap={1}>
                <Button variant="contained" color="secondary" onClick={props.onCancel}>Cancel</Button>
                <Button variant="contained" color="primary" onClick={handleConfirm}>Confirm Payment</Button>
            </Box>

        </Box>
    )
}